import * as React from 'react';
import RcPagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import { PaginationContainer } from './Style';
import { useTranslation } from 'react-i18next';

type PaginationProps = {
  currentPage: number;
  totalPage: number;
  onPageChange: (pageNumber: number) => void;
};

const Pagination: React.FunctionComponent<PaginationProps> = ({
  currentPage,
  totalPage,
  onPageChange,
}): JSX.Element => {
  const { t } = useTranslation();

  const localeForPagination = {
    prev_page: t('Prev page'),
    next_page: t('Next page'),
    prev_5: t('5 pages forward'),
    next_5: t('5 pages next'),
  };

  return (
    <PaginationContainer id="pagination-container">
      <RcPagination
        onChange={onPageChange}
        current={currentPage}
        total={totalPage}
        locale={localeForPagination}
        defaultPageSize={1}
      />
    </PaginationContainer>
  );
};

export default Pagination;
